/*
 * Author: Harper Yan
 * File Created: Monday, 24-09-02 04:17 pm
 * Last Modified: Wednesday, 25-02-12 10:48 am, by Harper Yan
 */

import { useRouter } from 'next/router';
import { useAgreementActions } from '@/stores/useAgreementStore';
import { useCardStore } from '@/stores/useCardStore';
import { useDvaultStore } from '@/stores/useDvaultStore';
import { useRebateStore } from '@/stores/useRebateStore';
import { useUserStore } from '@/stores/useUserStore';
import usePrefetch from './usePrefetch';
export const useLogout = () => {
  const userLogout = useUserStore(state => state.logout);
  const clearVaultData = useDvaultStore(state => state.clearData);
  const clearCardInfo = useCardStore(state => state.clearCardInfo);
  const {
    clearData: clearAgreementInfo
  } = useAgreementActions();
  const clearCardTransactions = useCardStore(state => state.clearTransactions);
  const clearRebateData = useRebateStore(state => state.clearData);
  const router = useRouter();
  usePrefetch(['/login']);
  const logout = async () => {
    const data = await userLogout();
    if (data) {
      clearVaultData();
      clearCardInfo();
      clearCardTransactions();
      clearRebateData();
      clearAgreementInfo();
      router.push('/login');
      return true;
    }
    return false;
  };
  return logout;
};